import { useQuery } from "@tanstack/react-query";
import { useGeotabClient } from "@/components/GeotabClientContext";

export function useCurrentTripByDeviceIds(ids?: string[]) {
  const { geotabClient, activeSessionId } = useGeotabClient();

  return useQuery({
    queryKey: ["currentTrips", activeSessionId, ids],

    queryFn: async ({ signal }) => {
      if (!ids || ids.length === 0) {
        return Promise.resolve({});
      }

      const fetchPromises = ids.map(id =>
        geotabClient
          .get(
            "Trip",
            {
              deviceSearch: { id: id },
              fromDate: new Date(new Date().getTime() - 30 * 60000),
              toDate: new Date(),
            },
            1,
            signal,
          )
          .then(trips => {
            return { id, trip: trips[0] };
          }),
      );

      const results = await Promise.all(fetchPromises);

      const tripDict = results.reduce((acc, { id, trip }) => {
        if (id && trip) {
           
          //@ts-ignore
          acc[id] = trip;
        }
        return acc;
      }, {});

      return tripDict;
    }
  });
}
